<template>
  <div class="referred" id="referred">
    <v-card-text>
      <v-row>
        <v-col cols="10">
          <div class="choose-select">
            <v-select
              :items="post_items"
              :label="$t('select')"
              item-text="label"
              item-value="value"
              single-line
              v-model="selected_post"
            >
            </v-select>
          </div>

        </v-col>
        <v-col cols="2">
          <button @click="dialog_barcode=true,barcode_rec_id='',barcode_rec_code=''">
            <v-icon>
              mdi-barcode
            </v-icon>
          </button>

        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            placeholder="جستجو"
            v-model="search_list"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="req-list" >
        <div class="req-card" v-for="item in request_items_filtered" :id="item.Id" :key="item.Id">
          <div>
            <div class="flex-no-wrap justify-space-between">
              <div @click="goToDetail(item)">
                <div
                  class="req-name"
                  v-text="item.RequestName"
                ></div>

                <span class="req-code">{{ $t('requestNo') }}<span class="bold">
                    {{ item.RequestCode }}
                    </span>
                  </span>
                <span class="req-date">
                    {{ item.ReqReceivDate }}
                    <v-icon>
                      mdi-calendar-range
                    </v-icon>
                  </span>

                <div>
                  <div class="text-center">
                    <v-chip v-for="item_chip in item.PredefinedGlobal"
                            class="ma-1"
                            color="primary"
                    >
                      {{item_chip.Text}}:{{item_chip.Value}}
                    </v-chip>

                    <v-chip
                      v-for="item_chip in item.PredefinedChecked"
                      class="ma-1"
                      color="primary"
                    >
                      {{item_chip.Text}}:{{item_chip.Value}}

                    </v-chip>
                  </div>
                  <div class="address">
                    <v-icon>
                      mdi-map-marker
                    </v-icon>
                    {{get_request_address(item)}}
                  </div>

                  <div class="status">{{item.StatusName}}</div>

                </div>
              </div>
              <div v-if="item.IsFinalize == 1" @click="go_to_attachment(item)">
                <v-icon class="mt-3">
                  mdi-attachment
                </v-icon>
              </div>
            </div>

          </div>

        </div>

      </div>

    </v-card-text>
    <v-card-text>



    </v-card-text>
    <v-row justify="center">
      <v-dialog
        v-model="dialog_barcode"
        max-width="290"
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('barcode_reader') }}</v-card-title>
          <div>{{barcode_rec_code}}</div>
          <v-card-text>
            <v-row>
              <QrcodeStream @decode="onDecodeBarcode"></QrcodeStream>
            </v-row>

          </v-card-text>
          <v-card-actions class="">
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_barcode = false"
            >
              {{$t('cancel')}}
            </v-btn>
            <v-btn
              v-if="barcode_rec_id!=0"
              class="accept-btn"
              text
              @click="goToDetail_barcode()"
            >{{ $t('show_request') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from 'vue-qrcode-reader'
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        list: [],
        errors: [],
        post_items: [],
        selected_post: null,
        selected_branch: 0,
        search_list: "",
        request_items: [],
        request_items_filtered: [],
        last_request_items: [],
        show_loading: false,
        no_info: true,
        first_load: true,
        page: 0,
        dialog_barcode: false,
        first: true,
        barcode_rec_id: '',
        barcode_rec_code: '',
      }
    },
    components: {
      InfiniteLoading,
      QrcodeStream: QrcodeStream,
      QrcodeDropZone,
      QrcodeCapture,
    },
    watch: {
      search_list: function(){
        var self= this;
        // console.log("search changed",this.search_list)
        self.request_items_filtered = [];
      if(self.search_list==""){
        this.request_items_filtered = this.request_items;
      }else{
        this.request_items_filtered = [];
        this.request_items.forEach(function (val) {
          if(val.RequestName.includes(self.search_list) || val.RequestCode.includes(self.search_list)){
            self.request_items_filtered.push(val)
          }
        })
      }
      this.$forceUpdate()
      },
      selected_post: function (val) {
      if(this.first_load==false){
        this.page = 0
        this.request_items = []
        this.no_info = false
        this.get_branch_by_post()
        this.show_loading = true
        localStorage.setItem('selected_post', this.selected_post)
      }

      }
    },
    mounted() {
      this.get_posts()

    },

    methods: {
      goToDetail(item) {
        localStorage.setItem("refered_scroll_position", document.getElementById("referred").scrollTop);
    // console.log(document.getElementById("referred").scrollTop)
        if (item.IsFinalize == 1) {
          this.$router.push({name: 'ViewRequest', params: {rec_id: item.Id}})
        } else {
          this.$router.push({name: 'ViewPreRequest', params: {rec_id: item.Id}})
        }
      },
      goToDetail_barcode() {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        this.$router.push({path: '/report-request/view-request/' + this.barcode_rec_id})
      },
      go_to_attachment(item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if (item.IsFinalize == 1) {
          this.$router.push({path: '/report-request/view-request-all-attachments/' + item.Id})
        }
      },
      onDecodeBarcode(decodedString) {
        var self = this
        const send_data = {
          ReqCode: decodedString,
        }
        this.barcode_rec_code = decodedString;
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqInfoByReqCode', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // bus.$emit('show_toast', [2000, response.data])

              self.barcode_rec_id = response.data.ReqId;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_address(item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        return address
      },
      get_branch_by_post() {
        var self = this
        const send_data = {
          PartyId: this.selected_post,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetBranchIdByPartyId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;

              self.selected_branch = response.data.branchId
              self.first_load = false;
              self.get_pre_requests(null)
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_posts() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserParties', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.parties.forEach(function (number) {
                if(number.Id==0){
                  number.PartyName="همه شعب"
                }
                var obj = {label: number.PartyName, value: number.Id}
                self.post_items.push(obj)
              })
              if (self.post_items.length == 2) {
                console.log('self.post_items[1]', self.post_items[1])
                // self.selected_post = self.post_items[1].value
              }
              // console.log(localStorage.getItem('selected_post'))
              self.selected_post =0
              self.page = 0
              self.request_items = []
              self.no_info = false
              self.get_branch_by_post()
              self.show_loading = true
              localStorage.setItem('selected_post', this.selected_post)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_pre_requests() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          IsDriver: 0,
          Count: this.page,
          BranchId: this.selected_branch,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreRequestsByUserId', send_data, {})
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {
                self.request_items.push(number)
              })
              self.last_request_items = response.data.requests
              self.list = response.data.requests
              self.get_final_requests(response.data.requests.length)
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_final_requests(last_size) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          IsDriver: 0,
          BranchId: this.selected_branch,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserDevicesByExpertId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {

                // if(number.RequestCode.includes('R401_30299')){
                //   console.log("R found R401_30299",self.page,number);
                // }
                if(self.request_items.filter(x => x.RequestCode==number.RequestCode).length==0){
                  self.request_items.push(number)
                  self.last_request_items.push(number)
                }else{
                  console.log("dupplicate found")
                }

              })
              if (self.first) {
                self.first = false
              }
              if (last_size != 0 || response.data.requests.length != 0) {
                self.page++;
                self.get_pre_requests();
              } else {

                self.request_items_filtered = self.request_items;
                var scroll = localStorage.getItem("refered_scroll_position");

                if (scroll != null) {
                  setTimeout(() => {
                    document.getElementById("referred").scrollTop = scroll;
                  }, 500)
                }
              }

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
